module.exports = __webpack_public_path__ + "static/media/star-with-back.751623a9.svg";